import React from 'react';
import PlaceholderIcon from './CmsPlaceHolderIcons.svg';

const CmsPlaceholderIcons = () => {
  return <img srcSet={PlaceholderIcon} alt="Plaveholder Icon" />;
};
export default CmsPlaceholderIcons;
